import { toast } from "react-toastify";
import { Logout } from "../Components/Auth/isAuthenticated";
import { api } from "./Api";
import { IErroRest, IRest, IRestPaginate, IRestGetIEvent } from "./Interfaces";

export const getEventAll = async (
  offset: number,
  limit: number
): Promise<IRestPaginate> => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .get(`/pt_BR/events?offset=${offset}&limit=${limit}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRestPaginate) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const postEventNew = async (data: {
  name: string;
  description: string;
  bannerSubtitle: string;
  eventStartDate: string;
  eventEndDate: string;
  accessKey: string;
  showHome: string;
  url: string;
  estabilishment: string;
}): Promise<IRestGetIEvent> => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(`/admin/event`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRestGetIEvent) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        success: "Evento cadastrado com sucesso!",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const getEventID = async (id: string): Promise<IRestGetIEvent> => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .get(`/admin/event/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRestGetIEvent) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const putEvent = async (
  id: string,
  data: {
    name: string;
    description: string;
    bannerSubtitle: string;
    eventStartDate: string;
    eventEndDate: string;
    accessKey?: string;
    showHome: string;
    url: string;
    estabilishment?: string;
  }
): Promise<IRest> => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .put(`/admin/event/${id}`, data, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const deleteEvent = async (id: string) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .delete(`/admin/event/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            responseType: "json",
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const uploadImageEvent = async (id: string, formData: FormData) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(`/admin/upload/Event/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const uploadImageEventImage = async (id: string, formData: FormData) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(`/admin/upload/EventImage/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        success: "Evento enviado com sucesso!",
        pending: "Enviando imagem",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const uploadImageEventMapImage = async (
  id: string,
  formData: FormData
) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(`/admin/upload/EventMapImage/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        success: "Imagem do mapa enviada com sucesso!",
        pending: "Enviando imagem do mapa",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const uploadAdminEventImage = async (eventId: string) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(
            `/admin/event_image`,
            {
              event: eventId,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const uploadAdminEventMapImage = async (eventId: string) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .post(
            `/admin/event_map_image`,
            {
              event: eventId,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const deleteAdminEventImage = async (id: string) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .delete(`/admin/event_image/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        pending: "Excluindo imagem...",
        success: "Imagem excluída com sucesso!",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};

export const deleteAdminEventMapImage = async (id: string) => {
  try {
    return toast.promise(
      new Promise((resolve, reject) => {
        api
          .delete(`/admin/event_map_image/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response: IRest) => {
            return resolve(response);
          })
          .catch((error) => {
            return reject(error);
          });
      }),
      {
        pending: "Excluindo imagem do mapa...",
        success: "Imagem do mapa excluída com sucesso!",
        error: {
          render(ToastContentProps) {
            const data = ToastContentProps.data as unknown as IErroRest;
            return data.response.data.message;
          },
        },
      }
    );
  } catch (erro) {
    Logout();
    throw erro;
  }
};
